import React from 'react';
import { Modal } from 'react-bootstrap';
import styles from './MirrorJoin.module.scss';

function ConnectInfoModal({ show, onHide, ctaText = "Got it!" }) {
    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            size="lg"
            dialogClassName="connectInfoModal"
        >
            <Modal.Body className={styles.modalBody}>
                <svg className={styles.modalHeroIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
                    <line x1="8" y1="21" x2="16" y2="21" />
                    <line x1="12" y1="17" x2="12" y2="21" />
                </svg>
                <h3 className={styles.modalTitle}>What is Connect?</h3>
                <p className={styles.modalSubtitle}>Game night, supercharged. Play together — even when you're apart!</p>

                <div className={styles.modalSections}>
                    <div className={styles.modalSection}>
                        <svg className={styles.modalSectionIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                            <polyline points="9 22 9 12 15 12 15 22" />
                        </svg>
                        <h4 className={styles.modalSectionTitle}>Play Anywhere</h4>
                        <p className={styles.modalSectionText}>Friends in different houses? Each one connects their own screen!</p>
                    </div>

                    <div className={styles.modalSection}>
                        <svg className={styles.modalSectionIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
                            <line x1="8" y1="21" x2="16" y2="21" />
                            <line x1="12" y1="17" x2="12" y2="21" />
                        </svg>
                        <h4 className={styles.modalSectionTitle}>Go Big</h4>
                        <p className={styles.modalSectionText}>Cast the game onto the biggest TV in the house!</p>
                    </div>

                    <div className={styles.modalSection}>
                        <svg className={styles.modalSectionIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                            <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
                            <path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07" />
                        </svg>
                        <h4 className={styles.modalSectionTitle}>Your Volume</h4>
                        <p className={styles.modalSectionText}>Each screen has its own sound — pump it up or mute as you like!</p>
                    </div>

                    <div className={styles.modalSection}>
                        <svg className={styles.modalSectionIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="20 6 9 17 4 12" />
                        </svg>
                        <h4 className={styles.modalSectionTitle}>Just Hop In</h4>
                        <p className={styles.modalSectionText}>No login. No fuss. Pop in the room code and you're playing!</p>
                    </div>
                </div>

                <button className={styles.modalCta} onClick={onHide}>
                    {ctaText}
                </button>
            </Modal.Body>
        </Modal>
    );
}

export default ConnectInfoModal;
